import { makeStyles } from '@fluentui/react-components';

export const useCustomerMessageDialogStyles = makeStyles({
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    field: {
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
    },
    icon: {
        fontSize: '1rem',
    },
});
